/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FromStatusEnum } from './FromStatusEnum';
import {
    FromStatusEnumFromJSON,
    FromStatusEnumFromJSONTyped,
    FromStatusEnumToJSON,
    FromStatusEnumToJSONTyped,
} from './FromStatusEnum';
import type { ToStatusEnum } from './ToStatusEnum';
import {
    ToStatusEnumFromJSON,
    ToStatusEnumFromJSONTyped,
    ToStatusEnumToJSON,
    ToStatusEnumToJSONTyped,
} from './ToStatusEnum';
import type { TransitionTypeEnum } from './TransitionTypeEnum';
import {
    TransitionTypeEnumFromJSON,
    TransitionTypeEnumFromJSONTyped,
    TransitionTypeEnumToJSON,
    TransitionTypeEnumToJSONTyped,
} from './TransitionTypeEnum';

/**
 * Create and update a transition.
 * 
 * Enforces the rules the admin form enforces: a manual transition cannot carry a condition,
 * from and to status must differ, and the (workflow, from, to) triple is unique. The model
 * raises for the second of those in ``save()``, which would surface as a 500.
 * @export
 * @interface TransitionWrite
 */
export interface TransitionWrite {
    /**
     * 
     * @type {string}
     * @memberof TransitionWrite
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof TransitionWrite
     */
    workflow: string;
    /**
     * 
     * @type {FromStatusEnum}
     * @memberof TransitionWrite
     */
    fromStatus: FromStatusEnum;
    /**
     * 
     * @type {ToStatusEnum}
     * @memberof TransitionWrite
     */
    toStatus: ToStatusEnum;
    /**
     * 
     * @type {TransitionTypeEnum}
     * @memberof TransitionWrite
     */
    transitionType: TransitionTypeEnum;
    /**
     * Priority of the transition. Higher number means higher priority.
     * @type {number}
     * @memberof TransitionWrite
     */
    priority?: number;
    /**
     * 
     * @type {string}
     * @memberof TransitionWrite
     */
    condition?: string | null;
}



/**
 * Check if a given object implements the TransitionWrite interface.
 */
export function instanceOfTransitionWrite(value: object): value is TransitionWrite {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('workflow' in value) || value['workflow'] === undefined) return false;
    if ((!('fromStatus' in (value as Record<string, any>)) && !('from_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['fromStatus'] === undefined && (value as Record<string, any>)['from_status'] === undefined)) return false;
    if ((!('toStatus' in (value as Record<string, any>)) && !('to_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['toStatus'] === undefined && (value as Record<string, any>)['to_status'] === undefined)) return false;
    if ((!('transitionType' in (value as Record<string, any>)) && !('transition_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['transitionType'] === undefined && (value as Record<string, any>)['transition_type'] === undefined)) return false;
    return true;
}

export function TransitionWriteFromJSON(json: any): TransitionWrite {
    return TransitionWriteFromJSONTyped(json, false);
}

export function TransitionWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransitionWrite {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'workflow': json['workflow'],
        'fromStatus': FromStatusEnumFromJSON(json['from_status']),
        'toStatus': ToStatusEnumFromJSON(json['to_status']),
        'transitionType': TransitionTypeEnumFromJSON(json['transition_type']),
        'priority': json['priority'] == null ? undefined : json['priority'],
        'condition': json['condition'] === undefined ? undefined : json['condition'] === null ? null : json['condition'],
    };
}

export function TransitionWriteToJSON(json: any): TransitionWrite {
    return TransitionWriteToJSONTyped(json, false);
}

export function TransitionWriteToJSONTyped(value?: Omit<TransitionWrite, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workflow': value['workflow'],
        'from_status': FromStatusEnumToJSON(value['fromStatus']),
        'to_status': ToStatusEnumToJSON(value['toStatus']),
        'transition_type': TransitionTypeEnumToJSON(value['transitionType']),
        'priority': value['priority'],
        'condition': value['condition'],
    };
}

